export default {
  loading: 'Loading...',
  noItemsFound: 'No items found',
  itemsWillAppear: 'Items will appear here when available',
  page: 'Page'
}
